import React, { useState } from "react";

// Dark code block with a hover "Copy" button. Standalone (no app dependencies)
// so the public docs page renders cleanly outside the authenticated app shell.
const CodeBlock = ({ code, label }) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div style={{ position: "relative", marginBottom: 12 }}>
      {label && (
        <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, color: "#8a9499", marginBottom: 4 }}>
          {label}
        </div>
      )}
      <button
        onClick={copy}
        style={{
          position: "absolute", top: label ? 22 : 6, right: 6, zIndex: 1,
          fontSize: 11, padding: "2px 8px", borderRadius: 4, cursor: "pointer",
          border: "1px solid #3a464c", background: "#2a343a", color: "#cfd6d9"
        }}
      >
        {copied ? "Copied" : "Copy"}
      </button>
      <pre
        style={{
          background: "#1A2226", color: "#e6edf0", padding: "12px 14px",
          borderRadius: 6, overflowX: "auto", fontSize: 13, lineHeight: 1.5,
          margin: 0, border: "1px solid #2a343a"
        }}
      >
        <code>{code}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
